import React from 'react';
import {Totals} from '../../../../../common/components/Totals/Totals';
import {TotalsSectionDataHooks} from '../TotalsSection';
import {useControllerProps} from '../../../Widget/ControllerContext';
import {TotalUpdateSkeleton} from '../../TotalUpdateSkeleton';
import {useExperiments, useEnvironment} from '@wix/yoshi-flow-editor';
import {SPECS} from '../../../../../common/constants';
import {formatSignedAmount, isFreeShippingCoupon} from '../../../../../domain/utils/total.util';
import {useLocaleKeys} from '../../../../../locale-keys/LocaleKeys';
import {TagSmall} from '@wix/wix-ui-icons-common';
import {classes} from './DiscountRows.st.css';
import {Text} from '@wix/wix-ui-tpa/cssVars';

export enum DiscountRowsDataHook {
  DiscountIcon = 'DiscountRows.DiscountIcon',
  DiscountName = 'DiscountRows.DiscountName',
  DiscountValue = 'DiscountRows.DiscountValue',
}

export const DiscountRows = () => {
  const {experiments} = useExperiments();
  const {isCartSummaryUpdating, cart, cartSummary} = useControllerProps().checkoutStore;
  const {isRTL} = useEnvironment();
  const localeKeys = useLocaleKeys();
  const couponAlignmentInCartAndCheckoutEnabled = experiments.enabled(SPECS.CouponAlignmentInCartAndCheckout);

  const getDiscountValue = () => {
    if (isCartSummaryUpdating || !cartSummary || !cartSummary.couponDiscount) {
      // eslint-disable-next-line react/display-name
      return () => <TotalUpdateSkeleton />;
    }

    if (isFreeShippingCoupon(cartSummary.couponDiscount, couponAlignmentInCartAndCheckoutEnabled)) {
      return localeKeys.checkout.order_summary.totals.discount.free_delivery();
    }

    return formatSignedAmount({amount: cartSummary.priceSummary.discount.formattedAmount, isRTL});
  };

  const renderTitleWithIcon = () => {
    return (
      <div className={classes.discountTag}>
        <TagSmall className={classes.discountIcon} data-hook={DiscountRowsDataHook.DiscountIcon} />
        <Text data-hook={DiscountRowsDataHook.DiscountName} className={classes.discountNameText}>
          {cart.coupon?.code}
        </Text>
      </div>
    );
  };

  return (
    <Totals.TotalsRow
      dataHook={TotalsSectionDataHooks.DiscountRow}
      title={renderTitleWithIcon}
      value={getDiscountValue()}
    />
  );
};
